/* ラベルなしチェックボックス */
import React, { memo } from 'react';
import { Form, InputGroup } from 'react-bootstrap';
import Messages from '../molecules/Messages';
import { KeyValue } from '../types/KeyValue';

interface Props {
  id: string;
  value: string[];
  need?: boolean;
  sources: Array<KeyValue>;
  name: string;
  handleChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  handleBlur?: () => void;
  message?: string;
  help_msg?: string;
  disabled: boolean;
  fm_id: number;
}

const NoLabelCheckBox: React.FC<Props> = ({
  id,
  value,
  sources,
  name,
  message,
  help_msg,
  disabled,
  handleChange,
  handleBlur,
  fm_id,
}) => {
  return (
    <>
      <InputGroup>
        {sources.map((src, index) => {
          return (
            <label className="check-box-label" key={src.key}>
              <Form.Check
                disabled={disabled}
                id={`${id}-${index}`}
                type="checkbox"
                inline
                value={src.key}
                name={name}
                defaultChecked={value.includes(src.key)}
                onChange={handleChange}
                onBlur={handleBlur}
                className="check-box"
                data-fm_id={fm_id}
              />
              {src.value}
            </label>
          );
        })}
      </InputGroup>
      {disabled || <Messages help_msg={help_msg} valid_msg={message} />}
    </>
  );
};

export default memo(NoLabelCheckBox);
